const noticiaFieldTypes = {
  idPrograma: "int",
  idNoticia: "int",
  nombre: "string",
  template: "string",
  fechaInicio: "date",
  fechaFin: "date",
  limiteDiasVisualizacion: "int",
  frecuenciaDiaria: "int",
  segmentos: "array",
  requiereLogin: "bool"
};

export const buildVariables = values => {
  const variables = {};
  Object.entries(noticiaFieldTypes).forEach(([key, type]) => {
    let value = values[key];

    // Si el campo no existe en values, lo ignora
    if (typeof value === "undefined") return;

    switch (type) {
      case "int":
        variables[key] = parseInt(value);
        break;
      case "date":
        variables[key] = new Date(value);
        break;
      default:
        variables[key] = value;
        break;
    }
  });
  return variables;
};
